(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-template"]) return;
  try {
    

  // 详情页产品标题加入后缀名
  const product__title  =$(".product-single__title").text()
  changeProduct__title()
  function changeProduct__title(){
    var thisColor =$("#ProductSelect-option-0 input:checked").attr("value")?` - ${$("#ProductSelect-option-0 input:checked").attr("value")}`:``;
    var thisSize =$("#ProductSelect-option-1 input:checked").attr("value")?` - ${$("#ProductSelect-option-1 input:checked").attr("value")}`:``;
    var thisCup =$("#ProductSelect-option-2 input:checked").attr("value")?` - ${$("#ProductSelect-option-2 input:checked").attr("value")}`:``;
    var thisProduct__title =`${product__title}${thisColor}${thisSize}${thisCup}`;
    $(".product-single__title").text(thisProduct__title)      
  }
  $("#ProductSelect-option-1,#ProductSelect-option-0,#ProductSelect-option-2").click(function(){
    changeProduct__title()
  })

  var $qtyadd = $(".more");
  var $qtyminus = $(".less");
  $qtyadd.each(function(){
    $(this).click(function(){
      var $qtynum = $(this).parent().find(".input-num");
      var qtynum = $qtynum.val();
      var qtycur = parseInt(qtynum)+1;
      $qtynum.val(qtycur);
      $qtynum.attr("value",qtycur);
    });
  });

  $qtyminus.each(function(){
    $(this).click(function(){
      var $qtynum = $(this).parent().find(".input-num");
      var qtynum = $qtynum.val();
      if(qtynum <= 1){
      }else{
        var qtycur = parseInt(qtynum)-1;
        $qtynum.val(qtycur);
        $qtynum.attr("value",qtycur);
      }
    });
  });
                                
  var ProductThumbs = new Swiper('#ProductThumbs', {
        slidesPerView: 6,
        spaceBetween: 0,
        mousewheel: true,
        resistanceRatio : 0,
        slideToClickedSlide: true,          
        autoplay: {
          delay: 2000,
          stopOnLastSlide: false,
          disableOnInteraction: true,
        },  
        navigation: {
          nextEl: '.ProductThumbs-next',
          prevEl: '.ProductThumbs-prev',
        },
      });
                           

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by-cateaories"] && !window.DesignMode) return;
  try {
    
  var newSale = new Swiper('.featured-list', {
    resistanceRatio : 0,
    slidesPerView: 6,
    spaceBetween: 20,
    loop:true,
    navigation: {
        nextEl: '.featured-list-next',
        prevEl: '.featured-list-prev',
    },
    breakpoints: { 
     //当宽度小于等于480
      591: { 
        slidesPerView: 2,
        spaceBetween: 10,
        autoplay: {
          delay: 2000,
        },
      },
      //当宽度小于等于640
      769: {
        slidesPerView: 3,
      }
    }
  });

  } catch(e) { console.error(e); }
})();
})();
